<maps-drawer variant="modal" label="Contact candidates" [closeGuard]="GuardClose" (closed)="closed.emit()" #modal>
    <div drawerTitle class="heading" data-testid="contact-modal">
        <h2>{{ title }}</h2>
        <p class="sub">Delivered through the AGU member messaging relay.</p>
    </div>

    <div class="body-stack" *ngIf="recipientRows === null; else resultsView">
        <section aria-label="Recipients">
            <h3 class="field-label">Recipients</h3>
            <ul class="recipients">
                <li class="recipient" *ngFor="let r of recipients">
                    <span class="dot" aria-hidden="true"></span>
                    {{ r.name }}
                </li>
            </ul>
            <p class="cap-warning" role="alert" data-testid="contact-cap-warning" *ngIf="overCap">
                Messages are capped at {{ cap }} recipients — deselect {{ overCapBy }} to send.
            </p>
        </section>

        <label class="field">
            <span class="field-label">Subject</span>
            <input type="text" [(ngModel)]="subject" placeholder="Subject" maxlength="200" [disabled]="isSending" />
        </label>

        <label class="field">
            <span class="field-label">Message</span>
            <textarea
                rows="5"
                [(ngModel)]="message"
                placeholder="A short introduction and the role details…"
                [disabled]="isSending"></textarea>
        </label>

        <p class="send-error" role="alert" data-testid="contact-send-error" *ngIf="errorMessage">{{ errorMessage }}</p>
    </div>

    <!-- Per-recipient outcomes: shown whenever any recipient did not send, so
         a partial failure can never masquerade as success. Statuses are TEXT,
         never color alone. -->
    <ng-template #resultsView>
        <div class="body-stack" data-testid="contact-send-results">
            <p class="results-summary" role="status">
                Sent to {{ sentCount }} of {{ recipientRows!.length }} — {{ recipientRows!.length - sentCount }} failed.
                <span *ngIf="isTestDelivery" class="test-note" data-testid="contact-test-note">
                    Test mode — nothing was delivered to candidates.
                </span>
            </p>
            <ul class="results">
                <li
                    class="result-row"
                    *ngFor="let row of recipientRows"
                    [class.ok]="row.status === 'Sent'"
                    [class.err]="row.status !== 'Sent'">
                    <span class="name">{{ row.name }}</span>
                    <span class="status">{{ StatusLabel(row) }}<ng-container *ngIf="row.error"> — {{ row.error }}</ng-container></span>
                </li>
            </ul>
        </div>
    </ng-template>

    <!-- One always-projected footer; states switch INSIDE it (a structural
         directive on the projected element itself would break slot matching). -->
    <div drawerFooter class="footer-actions" [class.discard]="confirmDiscard">
        <!-- Inline discard confirm: replaces the footer content while a dirty
             draft is about to be lost. Inline by necessity — the native dialog
             owns the top layer (ui-best-practices §6). -->
        <ng-container *ngIf="confirmDiscard">
            <p class="discard-question" role="alert" data-testid="contact-discard-confirm">Discard this message?</p>
            <span class="footer-spacer" aria-hidden="true"></span>
            <button type="button" class="btn secondary" data-testid="contact-keep-editing" (click)="KeepEditing()">Keep editing</button>
            <button type="button" class="btn danger" data-testid="contact-discard" (click)="Discard()">Discard</button>
        </ng-container>

        <ng-container *ngIf="!confirmDiscard && recipientRows !== null">
            <span class="footer-spacer" aria-hidden="true"></span>
            <button type="button" class="btn primary" data-testid="contact-done" (click)="Done()">Done</button>
        </ng-container>

        <ng-container *ngIf="!confirmDiscard && recipientRows === null">
            <span class="footer-spacer" aria-hidden="true"></span>
            <button type="button" class="btn secondary" [disabled]="isSending" (click)="modal.Close()">Cancel</button>
            <button
                type="button"
                class="btn primary"
                data-testid="contact-send"
                [disabled]="!canSend"
                [attr.aria-disabled]="!canSend"
                (click)="Send()">
                <span *ngIf="!isSending">Send message</span>
                <span *ngIf="isSending" class="sending"><span class="spinner" aria-hidden="true"></span> Sending…</span>
            </button>
        </ng-container>
    </div>
</maps-drawer>
